import { render, staticRenderFns } from "./BookingClientModal.vue?vue&type=template&id=08d45fd4&scoped=true&"
import script from "./BookingClientModal.vue?vue&type=script&lang=js&"
export * from "./BookingClientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d45fd4",
  null
  
)

export default component.exports